var _typeof = require("/Users/ievabumbuliene/Documents/pastovu/mwe_paieska/mwe_web_system/frontend/mwe_search/node_modules/@babel/runtime/helpers/typeof");

module.exports = function (it) {
  return _typeof(it) === 'object' ? it !== null : typeof it === 'function';
};